// extracted by mini-css-extract-plugin
module.exports = {"League":"style_League__3UgqH","LeagueTdTh":"style_LeagueTdTh__3Fwo0"};